<script lang="ts">
  import Variance from './sections/Variance.svelte';
</script>

<Variance />
